import React, { useState } from 'react';
import css from './brochurepagecomponent.module.css';
import Wave from '../Wave/Wave';
import consultIcon from '../../assets/consult.png';
import { ReactComponent as LineSmallSvg } from '../../assets/crissCrossSmall.svg';
import { ReactComponent as LineSmallSvgNew } from '../../assets/crissCrossSmallNew.svg';
import { ReactComponent as LineSmallSvgNew2 } from '../../assets/crissCrossSmallNew2.svg';
import { ReactComponent as LineSvg } from '../../assets/crissCrossLine.svg';
import NamedLink from '../NamedLink/NamedLink';
import SwitchUserModal from '../SwitchUserModal/SwitchUserModal';
import BusinessFormContainer from '../BusinessFormContainer/BusinessFormContainer';
import StarImg from '../../assets/star.png';
import classNames from 'classnames';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';

const s3Url = `${process.env.REACT_APP_CLOUDFRONT_URL}/individual-provider`;
const s3DefaultUrl = process.env.REACT_APP_STATIC_ASSETS_URL;
const startedButton = ({ isAuthenticated, isProvider, setModalOpen, forStart }) => {
  if (!isAuthenticated) {
    return !forStart ? (
      <NamedLink name="SignupProviderPage" className={css.getStartedLink}>
        Get started for FREE
      </NamedLink>
    ) : (
      <NamedLink name="SignupProviderPage" className={css.startBtn}>
        Start Today
      </NamedLink>
    );
  } else if (isAuthenticated && !isProvider) {
    return !forStart ? (
      <div className={css.getStartedLink} onClick={() => setModalOpen(true)}>
        Get started for FREE
      </div>
    ) : (
      <div className={css.getStartedLink} onClick={() => setModalOpen(true)}>
        Start Today
      </div>
    );
  } else {
    return !forStart ? (
      <NamedLink name="CreateListingPage" className={css.getStartedLink}>
        Get started for FREE
      </NamedLink>
    ) : (
      <NamedLink name="CreateListingPage" className={css.getStartedLink}>
        Start Today
      </NamedLink>
    );
  }
};
const liContent = [
  <>
    <span> Revenue Calculator</span> predict your outcomes and set prices with confidence before you
    publish.
  </>,
  <>
    <span>Trial Spaces</span> to welcome newcomers and encourage first-time bookings
  </>,
  <>
    <span>Sibling or Bring-a-Friend Discounts </span> encourage larger bookings and fill more spots
  </>,
  <>
    <span>Early Bird Discount </span>rewards quick sign-ups and enjoy early cash flow
  </>,
  <>
    <span>Late Joiner Sales</span> and fill remaining spots even after classes begin to maximise
    income.
  </>,
  <>
    <span>Early Drop-off and Late Pick-up </span>support busy parents while earning easy extra
    income
  </>,
  <>
    <span>Deposits and Cash Balance </span>always know who owes what, with payments made simple
  </>,
  //   <>
  //     <span>Visible reviews—attracts new customers</span>
  //   </>,
  //   <>
  //     <span>Website integration—seamlessly add our tools to boost your website</span>
  //   </>,
];

const essentialFeatures = [
  {
    title: 'Seamless Parent Experience',
    desc:
      'Give families a simple way to book your activities. With mobile-friendly booking, saved profiles for faster checkout and easy updates, parents will love how effortless it is to join your activities.',
  },
  {
    title: 'Post it, Share it, Fill it.',
    desc:
      'Each listing is automatically styled and ready to share straight to Facebook, WhatsApp and more — no extra tools, no extra effort. Just publish, share and watch the bookings roll in.',
  },
  {
    title: 'Flexible Scheduling',
    desc:
      'Create and update your schedules in minutes. Whether you’re offering term classes, one-off workshops or seasonal camps. Activity Time makes it easy to be organised and full.',
  },
  {
    title: 'Simple Pricing and Payments',
    desc:
      'Set your prices your way. Offer single sessions, full-term packages, trial spaces or special discounts. Plus, streamline your cashflow and automate payments with flexible fee options.',
  },
  {
    title: 'Built-in Reporting Essentials',
    desc:
      'Access clear, real-time booking data whenever you need it. Track enrolments, download attendee lists and spot trends — helping you make smart decisions to grow your business.',
  },
  {
    title: 'Connection Made Simple',
    desc:
      'Build loyalty, fill classes and keep families in the loop — all from one place. From auto-generated sign-in sheets to instant email blasts, you’ll save time and stay top-of-mind.',
  },
];
const CallTheShotsSection = () => (
  
  <div className={css.CallTheShotsSectionWrapper}>
    <div className={css.workStyleForCall}>
      <div className={css.imagediv}>
        {/* <img src={CalltheshotImage} alt="CalltheshotImage" /> */}
        <img src={`${s3DefaultUrl}/CalltheshotImageNew.png`} alt="CalltheshotImage" />
      </div>
      <div className={css.infoDiv}>
        <p className={css.infoHeading}>Call the shots for your business - with modern software</p>
        <p className={css.infoDesc}>
          Easily build custom listings, offer flexible payment types, automatically collect important information, communicate with customers and fill your classes, camps and workshops.
        </p>
      </div>
    </div>
  </div>
);

const BrochurePageComponent = props => {
  const {
    isAuthenticated,
    isProvider,
    headingText,
    headingTextMob,
    pageName,
    pageDescription,
    pageBannerImg,
    secondSecTitle,
    secondSecSubTitle,
    secondSecMainPic,
    secondSecLogo,
    secondSecDesc,
    secondSecName,
    secondSecNameDes,
    secondSecSub,
    thirdSecFirstTitle,
    thirdSecFirstPic,
    thirdSecSecondTitle,
    thierdSecSecondPic,
    thirdSecParaText,
    testimonialPic,
    testimonialTitle,
    testimonialDesc,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div className={css.wrapperDiv}>
      {' '}
      <section className={` ${css.HeadWrapper}`}>
        <div className={css.showMob}>{headingTextMob}</div>
        <div className={css.perkCrd}>
          <div className={classNames(css.perkDiv1, css.firstperkdiv)}>
            {headingText}
            <p className={css.subheader}>
              {pageName}{' '}
              {pageName !== 'Multi-Activity' && pageName !== 'Cooking & Baking' && 'Activity'}{' '}
              Providers
            </p>
            <p className={css.inspireP}>{pageDescription}</p>
            {startedButton({
              isAuthenticated,
              isProvider,
              setModalOpen,
              forStart: false,
            })}
          </div>
          <div className={css.perkDiv2}>
            <div className={css.plogodv}>
              <img src={`${s3DefaultUrl}/${pageBannerImg}`} className={css.mainBannerImg} />
              <img src={`${s3DefaultUrl}/${pageBannerImg}`} className={css.mainImgMob} />
            </div>
          </div>
        </div>
        {/* </div> */}
      </section>
      <section className={css.greySection}>
        <Wave className={css.wave} colName={`#f2f1ef`} />
        <div className={`${css.secondContainerWarpper} ${css.removeMarginBottom}`}>
          <p className={`${css.firstHeading} ${css.BlackText}`}>{secondSecTitle}</p>
          <p className={`${css.gridCardHead} ${css.color}`}>{secondSecSubTitle} </p>
          <div className={`${css.perkCrd} ${css.flex_direction}`}>
            <div className={css.perkDiv1}>
              <img className={css.mainImg} src={`${s3DefaultUrl}/${secondSecMainPic}`} alt="" />
              <div className={css.revCrd}>
                <img
                  src={`${s3DefaultUrl}/${secondSecLogo}`}
                  alt="Activity Time Photo"
                  className={css.stemClub}
                />
                <p className={css.RevCardname}>
                  <span>{secondSecName}</span>,&nbsp;{secondSecNameDes}
                </p>
                <div className={css.starDiv}>
                  <img src={StarImg} alt="star" />
                </div>
                <p>{secondSecDesc}</p>
              </div>

              <p className={css.belowImgText}>
                {secondSecSub}
                <span className={css.tiltedHeighlight}>
                  <span className={css.innerTiltText}>easier</span>
                </span>{' '}
                for you{' '}
              </p>
            </div>
            <div className={`${css.perkDiv2} ${css.removePad}`}>
              <BusinessFormContainer
                isIndividualProvider={true}
                mainClassName={css.bsnfrmOverride}
                tncCls={css.tncCls}
                setModalOpen={setModalOpen}
                isAuthenticated={isAuthenticated}
              />
            </div>
          </div>
        </div>
      </section>
      <section className={css.whiteSection}>
        <Wave className={css.wave} colName={`#fff`} />

        <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
          <p className={css.firstHeadingTopHead}>
            {thirdSecFirstTitle}
            <br />
          </p>
          <div className={css.perkCrdFormotivate}>
            <div className={css.perkDiv1}>
              <p className={css.firstHeadingTop}>
                {thirdSecFirstTitle}
                <br />
              </p>
              <p className={classNames(css.inspireP, css.overr)}>Easy online bookings.</p>
              <p>
                No more WhatsApps back n’ forth, manual spreadsheets, sending banking links and
                missed earnings. Activity Time makes it simple for customers to book their spot in
                your next camp, class, or workshop — whether it’s a one-off workshop, a term of
                training, or seasonal camps.
              </p>
              <p className={css.inspirePnew}>You can stop the late night admin now.</p>
            </div>
            <div className={css.perkDiv2}>
              <div className={css.plogodv}>
                <img src={`${s3DefaultUrl}/${thirdSecFirstPic}`} className={css.mainImg} />
              </div>
            </div>
          </div>
        </div>
        <div className={`${css.whiteSection} ${css.cust}`}>
          {/* <div className={css.backgroundGrad}></div>
          <div className={`${css.secondContainerWarpper} ${css.pos}`}>
            <p className={`${css.firstHeading} ${css.businessHead}`}>
              {thirdSecSecondTitle}
            </p>
            <div className={css.perkCrdBusiness}>
              <div className={`${css.perkDiv1} ${css.weKnowSec}`}>
                <p className={`${css.firstHeading} ${css.businessHead}`}>
                  {thirdSecSecondTitle}
                </p>
                <div className={css.grad_background}>
                  <p className={css.whiteText}>
                    {thirdSecParaText}
                  </p>
                  <p className={`${css.whiteText} `}>
                    <span className={css.allyourdomain}>All your admin in one place:</span>
                    <ul>
                      <li className={css.middlevioletList}>
                        Auto-filled attendee and sign-in sheets (with names, ages, medical, contact
                        and emergency details, etc)
                      </li>
                      <li className={css.middlevioletList}>
                        Automated notifications for new bookings, reminders and reviews
                      </li>
                      <li className={css.middlevioletList}>
                        Auto-filled group emails or individual buyer messaging to stay connected
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
              <div className={`${css.perkDiv2} ${css.pos}`}>
                <img src={`${s3DefaultUrl}/${thierdSecSecondPic}`} className={css.mainImg} />
                <div>
                  <p className={css.newBusinessText}>
                    Use{' '}
                    <span className={css.tiltedHeighlight}>
                      {' '}
                      <span className={css.innerTiltText}>100%</span>
                    </span>{' '}
                    of what you pay for
                  </p>
                </div>
              </div>
            </div>
          </div> */}
          <div className={css.randomTextCont}>
            <p className={classNames(css.firstHeading, css.busiMainTextNew)}>
              {thirdSecSecondTitle}
            </p>
          </div>

          <div className={css.busiContainer}>
            <div className={css.busiLeft}>
              <div className={css.busiImgCont}>
                <img src={`${s3DefaultUrl}/${thierdSecSecondPic}`} />
              </div>
              <div className={css.busiImgText}>
                <p className={css.newBusinessText}>
                  Use{' '}
                  <span className={css.tiltedHeighlight}>
                    {' '}
                    <span className={css.innerTiltText}>100%</span>
                  </span>{' '}
                  of what you pay for!
                </p>
              </div>
            </div>
            <div className={css.busiRight}>
              <div>
                <p className={classNames(css.whiteText, css.rightInnerText)}>{thirdSecParaText}</p>
                <p className={`${css.whiteText} ${css.listBox}`}>
                  <span className={css.allyourdomain}>All your admin in one place:</span>
                  <ul>
                    <li className={css.middlevioletList}>
                      Auto-filled attendee and sign-in sheets (with names, ages, medical, contact
                      and emergency details, etc)
                    </li>
                    <li className={css.middlevioletList}>
                      Automated notifications for new bookings, reminders and reviews
                    </li>
                    <li className={css.middlevioletList}>
                      Auto-filled group emails or individual buyer messaging to stay connected
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${css.secondContainerWarpper} ${css.createSectionWrapper} ${css.changeMargin}`}
        >
          <p className={css.firstHeading}>Start Free, Grow When You’re Ready</p>
          <div className={classNames(css.perkCrd, css.startFree, { [css.revPrkcrd]: false })}>
            <div className={css.perkDiv1}>
              {/* <p>{firstHeading}</p> */}
              <p>
                Flexible pricing and add-ons
                {/* {mainHeading} */}
              </p>
              <p>
                We’ve built in smart features that make listing creation simple (even if you’re not
                tech-savvy) and give families the flexibility they expect — while boosting your
                bookings. With Activity Time you can offer:
              </p>

              <ul>
                {liContent.map((c, index) => {
                  const match = typeof c === 'string' ? c?.match(/^(.*?)(\s*\(.*\))$/) : null; // separate text and bracket part
                  return (
                    <li key={index} className={!false ? css.liCOntent : ''}>
                      {match ? (
                        <>
                          <IoCheckmarkCircleOutline />
                          <div>
                            {match[1]}
                            <span className={css.bracketClass}>{match[2]}</span>{' '}
                          </div>
                        </>
                      ) : (
                        <>
                          <IoCheckmarkCircleOutline />
                          <div>{c}</div>
                        </>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className={css.perkDiv2}>
              <div className={css.plogodv}>
                <img src={`${s3DefaultUrl}/stem_Group 2212.png`} className={css.mainImgGrow} />
                <img src={`${s3DefaultUrl}/brochure_mobImage.png`} className={css.mainImgGrowMob} />
              </div>
            </div>
          </div>
        </div>
        <div className={css.CalltheShotImageMobDiv}>
          <img src={`${s3DefaultUrl}/CalltheShotImageMob.png`} alt="CalltheShotImageMob" />
        </div>
        <CallTheShotsSection />
        <div className={css.whiteSection}>
          <div
            className={classNames(
              css.secondContainerWarpper,
              css.createSectionWrapper,
              css.override
            )}
          >
            <p className={css.firstHeading}>Essential features to love</p>
            <div className={css.gridContainer}>
              {essentialFeatures.map(info => (
                <div>
                  <p className={css.gridCardHead}>{info.title}</p>
                  <p className={css.gridCardDesc}>{info.desc}</p>
                </div>
              ))}
            </div>
            <div className={css.gridContainerMob}>
              {essentialFeatures.map(info => (
                <div>
                  <ul>
                    <li className={css.gridCardHead}>{info.title}</li>
                  </ul>
                  <p className={css.gridCardDesc}>{info.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={`${css.whiteSection} ${css.pos}`}>
          <div className={css.backgroundGrad2} />
          <div className={`${css.perkCrd} ${css.pos} ${css.workStyle}`}>
            {/* <div className={css.perkDiv2}> */}
            <img
              className={css.workImg}
              src={`${s3DefaultUrl}/brochure_workImg.png`}
              alt="Activity Time work Image"
            />
            <img
              className={css.workImgMob}
              src={`${s3DefaultUrl}/brochure_workImgMob.png`}
              alt="Activity Time work Image"
            />
            {/* </div> */}
            <div className={css.perkDiv1}>
              <div className={css.workTextContainer}>
                <p className={css.whiteText}>We work well with others</p>
                <p className={css.whiteText}>
                  Activity Time seamlessly integrates with your business - from website embeds to
                  multiple marketing integrations.{' '}
                </p>
                {/* <button type="button">Start Today</button> */}

                {startedButton({ isAuthenticated, isProvider, setModalOpen, forStart: true })}
              </div>
            </div>
          </div>
        </div>
        {pageName === 'Cooking & Baking' ? (
          <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
            <div className={css.NinaBakingDiv}>
              <div className={css.imgDiv}>
                <img src={`${s3DefaultUrl}/NInaBgImg.png`} />
              </div>
              <div className={css.reviewDesc}>
                <p className={css.RevCardname}>Nina, Baking and Cookery Classes</p>
                <div className={css.starDiv}>
                  <img src={StarImg} alt="star" />
                </div>
                <p className={css.reviewInfo}>
                  "I used to spend hours on admin, chasing payments and updating my website. Now
                  it’s like I have a full-time assistant or sous chef — without having to hire one."
                </p>
                <img src={`${s3DefaultUrl}/reviewLastImg.png`} className={css.ratinRoundFoodImg} />
              </div>
            </div>
          </div>
        ) : (
          <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
            <div className={classNames(css.revCrd)}>
              <img src={`${s3DefaultUrl}/${testimonialPic}`} alt="Activity Time Photo" />
              <p className={css.tutorialName}>– {testimonialTitle}</p>
              <div className={css.starDiv}>
                <img src={StarImg} alt="star" />
              </div>
              <p>{testimonialDesc}</p>
            </div>
          </div>
        )}
      </section>
      <section className={css.greySection}>
        <Wave className={css.wave} colName={`#f2f1ef`} />
        <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
          <div className={css.providerWrapper}>
            <div className={css.providerBoldTextWrapper}>
              <p className={css.boldProviderText}>
                Less admin,
                <br /> more action!
                <br /> Focus on what
                <br /> you <i>love</i> doing.
              </p>
              <div className={css.lineDiv}>
                <LineSmallSvg className={`${css.lineSvg}`} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`${css.whiteSection} ${css.lastSec}`}>
        <Wave className={css.wave} colName={`#fff`} />
        <div className={`${css.secondContainerWarpper} ${css.createSectionWrapper}`}>
          <div className={css.providerWrapper}>
            <div className={css.consultContainer}>
              <div className={css.btndv}>
                <h3>
                  <span>Got Questions?</span> We’d love to answer them...
                </h3>
                <NamedLink name="ContactUsPage">Contact Us</NamedLink>
              </div>
              <h3>
                Want to skip <br /> the forms?
              </h3>
              <img src={consultIcon} alt="" />
              <span className={css.projectOwner}>Audrey Vance</span>
              <span>Activity Time Founder</span>
              <button
                type="button"
                onClick={() => {
                  if (typeof window !== 'undefined') {
                    window.location.href = 'mailto:audrey@activity-time.com';
                  }
                }}
                className={css.button}
              >
                Schedule a Consultation
              </button>
            </div>
          </div>
        </div>
      </section>
      <SwitchUserModal modalOpen={modalOpen} isProvider={isProvider} setModalOpen={setModalOpen} />
    </div>
  );
};

export default BrochurePageComponent;
